import { render } from "./modifiermotdepasse.vue?vue&type=template&id=185e569d&scoped=true"
import script from "./modifiermotdepasse.vue?vue&type=script&lang=js"
export * from "./modifiermotdepasse.vue?vue&type=script&lang=js"

import "./modifiermotdepasse.vue?vue&type=style&index=0&id=185e569d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185e569d"]])

export default __exports__